import { ACCard } from '@antech-consulting/components';
import { style } from 'constants/StyleConstants';
import { ReactElement } from 'react';

import styles from './AverageOrderSizeCard.module.scss';

const AverageOrderSizeCard = ({
  data,
  header,
  icon,
}: {
  data: number;
  header: string;
  icon: ReactElement;
}) => {
  return (
    <ACCard
      bodyChildren={
        <div>
          <div style={style.StatisticHeader}>{header}</div>
          <div className={styles.description}>
            <div style={style.IconStatistics}>{icon}</div>
            <div style={style.DescriptionCardStatistics}>{data}</div>
          </div>
        </div>
      }
      className={styles.statisticsCard}
      dataTestiId='cardStatistic'
    />
  );
};

export default AverageOrderSizeCard;
